import OrderList from "@num/model/OrderList";

export default {
  state: {
    orderList: new OrderList(),
    orderFilter: "new,in_production,in_box_1,in_box_2,in_box_3,in_box_4,in_box_5,in_box_6",
    orderIntervalTime: -1,
    pickupArrowMap: {
      "in_box_1": "down",
      "in_box_2": "down",
      "in_box_3": "down",
      "in_box_4": "down",
      "in_box_5": "down",
      "in_box_6": "down",
    },
  }
}